export default __webpack_public_path__ + "static/media/prototype_banner_img2.8afab47e.png";